export default __webpack_public_path__ + "static/media/logo_500.4ffee3e5.png";